import axios from "axios";
import { checkStatus, getHeaders } from "../../../Services/SharedSevices/SharedServices";
import axiosInstance from "../../../Services/Global-Services/UnauthorizedTokenHandler";

const baseurl = process.env.REACT_APP_BASE_URL


export const Notifications = async (params) => {
  try {
    const response = await axiosInstance.post(
      `${baseurl}/Employee/Notifications`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const NotificationsRead = async (params) => {
  try {
    const response = await axiosInstance.post(
      `${baseurl}/Employee/Notification/Read`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
export const NotificationsRemove = async (params) => {
  try {
    const response = await axiosInstance.post(
      `${baseurl}/Employee/Notification/Remove`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const NotificationType = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseurl}/Employee/NotificationType`, {
      headers: await getHeaders(),
      body: JSON.stringify()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

